import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Flex, Copy, Button, Box } from '@elparking/components'
import Phone from '../Icons/Phone'
import ClickToCallModal from '../Modals/ClickToCallModal'
import { RENTAL_CAR_CLICK_TO_CALL_INFO } from 'commons/js/constants'
import styled from 'styled-components'
import { RentalCarEvents, trackTealiumEvent } from 'commons/js/services/analytics'
import useOnCloseModalAnalyticEvent from 'commons/js/hooks/useOnCloseModalAnalyticEvent'

const Container = styled(Flex)`
    border-radius: 3px 3px 20px 3px;
`

const HelpBox = ({onCloseAnalyticEvent = null}) => {
    const [showModal, setShowModal] = useState(false)
    useOnCloseModalAnalyticEvent(showModal, onCloseAnalyticEvent)
    const onClickC2CButton = () => {
        setShowModal(true)
        trackTealiumEvent(RentalCarEvents.clickC2Clink())
    }
    const handleOnLoadC2CModal = () => {
        trackTealiumEvent(RentalCarEvents.showC2CModal('resultados'))
    }
    const handleSuccessPhoneNumberCall = () => {
        trackTealiumEvent(RentalCarEvents.showC2cPhoneSent)
        trackTealiumEvent(RentalCarEvents.eventC2cPhoneSent)
    }
    return <Container borderRadius='4px' flexDirection='column' background='accent10' width='100%' padding='20px'>
        <ClickToCallModal
          isShown={showModal}
          onClose={() => setShowModal(false)}
          step='P2'
          modalType={RENTAL_CAR_CLICK_TO_CALL_INFO}
          onShowPrivacyModal={() => setShowModal(false)}
          onLoad={handleOnLoadC2CModal}
          onSuccessPhoneNumberCallSent={handleSuccessPhoneNumberCall}
        />
        <Copy fontSize='large' fontWeight='medium' fontColor='accent_dark'>
            <FormattedMessage defaultMessage='¿Necesitas más información?' />
        </Copy>
        <Copy fontSize='small' fontWeight='book'>
            <FormattedMessage defaultMessage='Llámanos al 914 500 600 o si lo prefieres' />
        </Copy>
        <Box mt='2em'>
            <Button.bordered width='100%' padding='0 8px' fontSize='small' fontWeight='medium' backgroundColor='transparent' onClick={() => onClickC2CButton()}>
                <Phone color='main' height='12px' /><FormattedMessage defaultMessage='Te llamamos gratis' />
            </Button.bordered>
        </Box>
    </Container>
}
export default HelpBox

HelpBox.propTypes = {
    onCloseAnalyticEvent: PropTypes.object,
}
